import React, { useState } from "react";
// import { RegisterWrap } from "./style";
import { Col, Row } from "react-bootstrap";
import DetailsForm from "../../../src/Components/Register/DetailsForm";
import { baseURL } from "../../Services/api";
import axios from "axios";
import { Spin, message, Alert } from "antd";
import { OTP } from "../../../src/Components/Register/OTP/OTP.js";
import logo from "../../Assests/Frame 2147225291.svg";
import { useNavigate } from "react-router-dom";
import { SetPassowrd } from "../../../src/Components/Register/SetPassword/index.js";
import ConfirmationModal from "../../../src/Components/Register/ConfirmationModal/index.js";
import styled from "styled-components";

// const NewBox = styled.div`
//   .container_one {
//     margin-top: 150px;
//   }
//   .container_two {
//     padding-top: 40px 20px 40px 20px;
//   }
//   .text_customization {
//     color: green;
//     font-size: 39px;
//     font-weight: 600;
//   }
//   .text_customizationtwo {
//     color: #002862;
//   }
//   .container_four {
//     display: flex;
//     justify-content: center;
//     flex-direction: column;
//     padding-left: 70px;
//   }
//   .container_five {
//     color: #002862;
//     font-size: 25px;
//     font-weight: 500;
//   }
//   .container_six {
//     margin-top: 30px;
//   }
// `;

const NewBox = styled.div`
  * {
  }
  .container_seven {
    padding: "80px";
  }

  .container_two {
    background-color: green;
    border-radius: 18px;
  }
  .container_three {
    margin-top: 100px;
  }
  .container_one {
    height: 900px;
    margin-top: 70px;
    padding: 10px 15px 20px 15px;
  }
  .container_four {
    display: flex;
    flex-direction: column;
    padding-left: 70px;
    margin-top: 150px;
  }

  .subtitle {
    color: #002862;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 12px;
  }

  .title {
    color: #2f8f2f;
    font-size: 42px;
    font-weight: 700;
    line-height: 1.25;
    margin-bottom: 30px;
  }

  .container_six {
    margin-top: 20px;
  }

  ul {
    padding-left: 18px;
  }

  li {
    color: #002862;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 12px;
  }
`;

const Freetrail = () => {
  const navigate = useNavigate();

  const [registerdata, setRegisterData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    companyName: "",
    jobTitle: "",
    domain: "",
    employees: "",
    country: "",
    terms: false,
  });

  const [messageApi, contextHolder] = message.useMessage();
  const [domainstatus, setDomainStatus] = useState("");
  const [domainsuccess, setDomainSuccess] = useState(false);
  const [urlloader, setUrlLoader] = useState();
  const [alertMsg, setAlertMsg] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [active, setActive] = useState("");
  const [token, setToken] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const [otpError, setOtpError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("");

  const [show, setShow] = useState(false);

  const handleOnChange = (e) => {
    setRegisterData({ ...registerdata, [e.target.name]: e.target.value });
  };

  const handleChangeDomain = async (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    if (value.length === 0) {
      setDomainStatus("error");
      setDomainSuccess(false);
      return;
    }
    try {
      setUrlLoader(true);
      const payload = {
        domain: `${e.target.value}.foresyts.ai`,
      };
      const response = await axios.post(
        `${baseURL}/user/check-domain`,
        payload
      );
      if (response.data.status === true) {
        setDomainStatus("success");
        setShowAlert(false);
        setDomainSuccess(true);
        setUrlLoader(false);
        setAlertMsg("");
      } else {
        setDomainStatus("error");
        setShowAlert(true);
        setAlertMsg("Domain Already Exists");
        setDomainSuccess(false);
        setUrlLoader(false);
      }
    } catch {
      setUrlLoader(false);
      setDomainSuccess(false);
    }
  };

  const handleOtpVerification = async (otp) => {
    setOtpError(false);
    if (otp.length < 6) {
      setOtpError(true);
    } else {
      setLoading(true);
      try {
        const response = await axios.post(`${baseURL}/user/verify-otp`, {
          email: registerdata.email,
          otp: otp,
        });
        if (response.data.status) {
          messageApi.open({
            type: "success",
            content: "OTP verified successfully",
          });
          setActive("create-password");
          setLoading(false);
        } else {
          messageApi.open({
            type: "error",
            content: response.data.message,
          });
          setOtpError(false);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const handleResendOtpVerification = async (otp) => {
    try {
      const response = await axios.post(`${baseURL}/user/send-otp`, {
        email: registerdata.email,
      });
      if (response.data.status) {
        messageApi.open({
          type: "success",
          content: "OTP resend successfully",
        });
        setLoading(false);
      } else {
        messageApi.open({
          type: "error",
          content: response.data.message,
        });
      }
      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleCreatePassword = async (data) => {
    setLoading(true);
    try {
      const response = await axios.post(`${baseURL}/user/register`, {
        companyName: registerdata.companyName,
        country: registerdata.country,
        domain: registerdata.domain + ".foresyts.ai",
        email: registerdata.email,
        employeeCount: registerdata.employees,
        firstName: registerdata.firstName,
        interval: "month",
        lastName: registerdata.lastName,
        monthlyCost: 0,
        password: data.password,
        paymentType: "free",
        productList: "",
        totalCost: 0,
        type: "company",
        phoneNumber: selectedCountry + registerdata.phoneNumber,
      });
      if (response.data.status) {
        setLoading(false);
        setShow(true);
        setToken(response.data.authorizationToken);
      } else {
        messageApi.open({
          type: "error",
          content: response.data.message,
        });
      }
      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (domainsuccess) {
      setLoading(true);
      setSubmitted(false);
      try {
        const response = await axios.post(`${baseURL}/user/send-otp`, {
          email: registerdata.email,
        });
        if (response.data.status) {
          setActive("confirm-otp");
          setLoading(false);
        } else {
          messageApi.open({
            type: "error",
            content: response.data.message,
          });
        }
        setLoading(false);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <>
      <NewBox>
        <Row className="container_one">
          <Col lg={6}>
            <div className="container_four">
              <div>
                <p className="subtitle">Unlock Your Effective Management</p>

                <p className="title">
                  Book Your <br />
                  Personalized <br />
                  Demo Today
                </p>
              </div>

              <div className="container_six">
                <ul>
                  <li>Live Platform Walkthrough</li>
                  <li>Interactive Q&A Session</li>
                  <li>Personalized Recommendations</li>
                  <li>Tailored Solutions</li>
                </ul>
              </div>
            </div>
          </Col>

          <Col className="container_two" lg={6}>
            <Spin spinning={loading} className="container_seven">
              <div className="card p-4  container_three">
                {/* <img
                  src={""}
                  alt=""
                  width="200"
                  className="mx-auto pt-2 pb-3 cursor-pointer"
                  onClick={() => navigate("/")}
                /> */}
                {showAlert && (
                  <Alert
                    className="alert_box"
                    message={alertMsg}
                    type="error"
                  />
                )}
                {active === "create-password" ? (
                  <SetPassowrd handleCreatePassword={handleCreatePassword} />
                ) : active === "confirm-otp" ? (
                  <OTP
                    handleOtpVerification={handleOtpVerification}
                    setActive={setActive}
                    handleResendOtpVerification={handleResendOtpVerification}
                    otpError={otpError}
                    setOtpError={setOtpError}
                  />
                ) : (
                  <div className="">
                    <DetailsForm
                      handleChangeDomain={handleChangeDomain}
                      registerdata={registerdata}
                      domainstatus={domainstatus}
                      setDomainStatus={setDomainStatus}
                      setDomainSuccess={setDomainSuccess}
                      handleOnChange={handleOnChange}
                      onSubmit={onSubmit}
                      showAlert={showAlert}
                      alertMsg={alertMsg}
                      selectedCountry={selectedCountry}
                      setSelectedCountry={setSelectedCountry}
                      setActive={setActive}
                      submitted={submitted}
                      setSubmitted={setSubmitted}
                      setRegisterData={setRegisterData}
                    />
                  </div>
                )}
              </div>
            </Spin>
          </Col>
        </Row>
      </NewBox>
    </>
  );
};

export default Freetrail;
